module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.iterators.js
 ** module id = 10
 ** module chunks = 0
 **/